import type { TarotCard } from '@lilith-arcana-os/domain';

import { MAJOR_ARCANA_CORE } from '../cards/major';
import { MINOR_CUPS_CORE } from '../cards/minor-cups';
import { MINOR_PENTACLES_CORE } from '../cards/minor-pentacles';
import { MINOR_SWORDS_CORE } from '../cards/minor-swords';
import { MINOR_WANDS_CORE } from '../cards/minor-wands';

export const FULL_DECK_CORE: TarotCard[] = [
  ...MAJOR_ARCANA_CORE,
  ...MINOR_WANDS_CORE,
  ...MINOR_CUPS_CORE,
  ...MINOR_SWORDS_CORE,
  ...MINOR_PENTACLES_CORE,
];
